import { useState, useEffect } from 'react'
import axios from 'axios'
import '../css/miniprint.css'

import info from '../img/icons8-información-50.png'
import close from "../img/close.svg"
const initialDb = []

const Profundidades = () => {
    const [db, setDb] = useState(initialDb)

    const [isModalOpen, setIsModalOpen] = useState(false)

    const [currentIndex, setCurrentIndex] = useState(0)

    const [infor, setInfor ] = useState(false)


    useEffect(() => {
  if (isModalOpen) {
    document.body.style.overflow = 'hidden';
  }else{
    document.body.style.overflow = 'auto';
  }

  return()=>{
    document.body.style.overflow= 'auto'
  }
}, [isModalOpen])


    const getData = async () => {
        const ENDPOINT = "https://elsaback-q7jq.onrender.com/profundidades"
        const res = await axios.get(ENDPOINT),
            json = await res.data;

        setDb(json)
    }

    useEffect(() => {
        getData()
    }, [])

    const openModal = (index) => {
        setCurrentIndex(index)
        setIsModalOpen(true)
    }

     const openInfo = () => {

        setInfor(true)
    }
    const closeInfo = () => setInfor(false) 

    const closeModal = () => setIsModalOpen(false)

    const goNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % db.length)
    }

    const goPrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + db.length) % db.length)
    }

    const capitalizar = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

    return (
        <>
            <div className='sectionGaleria'>
                <div className='intro' >
                    <h2>Profundidades</h2>
                    <p>
                    Esta serie nace del deseo de construir imágenes que inviten a mirar más allá de lo evidente. 
                    Son grabados realizados lentamente, capa sobre capa, buscando texturas que no se imponen, sino que 
                    se descubren. Trabajo con veladuras, huellas, detalles sutiles que piden tiempo y atención. En estas
                     obras hay una búsqueda de lo que no se dice del todo, de lo que se insinúa más que se muestra. 
                     Me interesa esa emoción que no irrumpe, pero que deja una huella persistente. Son imágenes pensadas 
                     para ser habitadas, para dialogar en silencio con quien se detiene a mirar.
                    </p>
                </div>
                {
                    db.map((item, index) => <div key={item._id} className='divDb' onClick={() => openModal(index)} >
                        <div className='h3box'><h3 className='h3'>{item.name}</h3></div>
                        <img className='imgMiniprint' src={item.image} alt={item.name} />

                    </div>)
                }
            </div>
            {isModalOpen && (
                <div className='modal'>
                    {db[currentIndex].description  &&
                        <img src={info} className='informacion' alt='caracteristicas' onClick={openInfo}/>
                    }
                    <img src={close}  alt="cerrar" className='close' onClick={closeModal}/>
                    <span className='arrow left' onClick={goPrev}>‹</span>
                    <img className='modal-img' src={db[currentIndex].image} alt={db[currentIndex].name} />
                    <span className='arrow right' onClick={goNext}>›</span>
                    <h4 className='h4Name'>{capitalizar(db[currentIndex].name)}</h4>
                    <h4 className='h4Size'>{db[currentIndex].size}</h4>
                </div>
            )}
             {infor  && (
                <div className='informacionContainer'>

                <div className='inf'>
                        <div style={{display:'flex', width:'100%', justifyContent:'end'}}>
                            <span className='closeInformacion' onClick={closeInfo}>×</span>
                        </div>
                        
                        <h4 className='h4InfName'>{db[currentIndex].name.toUpperCase()}</h4>
                        <h4 className='description' style={{
                            fontWeight:'400'
                        }}>{db[currentIndex].description}</h4>
                        <h4 className='description' style={{
                            fontWeight:'400'
                        }}>Medidas: {db[currentIndex].size}</h4>
                        
                </div>
                    
                </div>
            )

            }
        </>
    )
}

export default Profundidades